import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const format = (value, roundTo, decimalPoint = '.', thousandSeparator = ',') => {
    value = value / 100;

    const d = decimalPoint;
    const t = thousandSeparator;

    let c = Math.abs(roundTo);
    c = isNaN(c) ? 2 : c;
    let s = value < 0 ? '-€' : '€';
    let i = String(parseInt(value = Math.abs(Number(value) || 0).toFixed(2), 10));
    let j = i.length > 3 ? i.length % 3 : 0;

    return s + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) + (c ? d + Math.abs(value - i).toFixed(2).slice(2) : '');
};

// TODO: Also accept currency
// TODO: Take currency from the global state?
const Money = ({value}) => (
    <Fragment>
        {format(value)}
    </Fragment>
);

Money.propTypes = {
    value: PropTypes.number.isRequired,
    currency: PropTypes.string,
};

export default Money;


// WEBPACK FOOTER //
// ./src/components/formatters/money-formatter.js